import { render, staticRenderFns } from "./movecard.vue?vue&type=template&id=733a3cfd&scoped=true&"
import script from "./movecard.vue?vue&type=script&lang=js&"
export * from "./movecard.vue?vue&type=script&lang=js&"
import style0 from "./movecard.vue?vue&type=style&index=0&id=733a3cfd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "733a3cfd",
  null
  
)

export default component.exports